<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar color="red" dark>
                <v-toolbar-title>Education Details</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-select required clearable :items="cities"  v-model="city_id" v-if="user.data.competition_id != null && user.data.category_id != null" item-text="name_en" label="City of University" color="red" append-icon="fa fa-arrow-down" autocomplete item-value="id">  
                  </v-select>

                  <!-- <v-select required clearable v-if="city_id != '' && user.data.competition_id != '' && user.data.category_id != ''" :items="[{id: 1 , category: 'School'},{ id: 0 , category: 'University'}]" v-model="affiliation_type" item-text="category" label="Education" color="red" append-icon="fa fa-arrow-down" autocomplete item-value="id">  
                  </v-select> -->

                  <v-text-field  clearable v-model="school_name" v-if="user.data.affiliation_type == 'school' && city_id != null && user.data.competition_id != null && user.data.category_id != null" append-icon="fa fa-university" :counter="50" label="School Name" :error-messages="errors.collect('school_name')" color="red" data-vv-name="school_name" data-vv-as="School Name" v-validate="{required: true, min: 10, max: 50, regex: /^[\u0621-\u064Aa-zA-Z0-9 ]+$/}" required>
                  </v-text-field>

                  <v-select clearable required v-if="user.data.affiliation_type == 'university' && city_id != null && user.data.competition_id != null && user.data.category_id != null" :items="filteredCity.universities"  v-model="university_id" item-text="name_en" label="University" color="red" append-icon="fa fa-arrow-down" autocomplete item-value="id">
                  </v-select>

                  <v-select clearable required v-if="user.data.affiliation_type == 'university' && city_id != null && user.data.competition_id != null && user.data.category_id != null && university_id != null" :items="colleges"  v-model="college_id" item-text="name_en" label="College" color="red" append-icon="fa fa-arrow-down" autocomplete item-value="id">  
                  </v-select>

                  <v-select clearable required v-if="user.data.affiliation_type == 'university' && city_id != null && user.data.competition_id != null && user.data.category_id != null && university_id != null && departments.length" :items="departments"  v-model="department_id" item-text="name" label="Department" color="red" append-icon="fa fa-arrow-down" autocomplete item-value="id">  
                  </v-select>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary"  @click.prevent="rollBack">Previous</v-btn>
                <v-btn color="success"  @click.prevent="proceed" :disabled="(errors.any() || isDisabled)">Next</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>  
</template>
<script>
    export default {
        props: ['cities','user','colleges'],
        data(){
          return {  
            city_id: null,
            university_id: null,
            school_name: null,
            college_id: null,
            department_id: null
          }
        },
        computed: {
          filteredCity(){
            let city = this.cities.find(city => city.id == this.city_id);
            this.user.data.city_accommodation = (city.has_accommodation == 1)
            return city;
          },
          isDisabled (){
            if (this.city_id != null && this.university_id != null && this.college_id != null) {
              if(this.departments.length){
                if(this.department_id != null){
                  return false
                }
              }else{
                return  false;
                
              }
            }else if( this.city_id != null && this.school_name != null){
              return false;
            }
            return true;
          },
          departments(){
            if(this.college_id != null){
              return this.colleges.find(college => college.id == this.college_id).departments
            }
            return [];
          }
        },
        methods: {
          rollBack(){
            this.$emit('rollback',this.user)
          },
          proceed (){
            if (this.user.data.affiliation_type == 'university') {
              this.user.data.university_id = this.university_id;
              if (this.departments.length) {
                this.user.data.department_id = this.department_id;
              }else{
                this.user.data.department_id = null
              }
              this.user.data.college_id = this.college_id
            } else {
              this.user.data.university_id = null;
              this.user.data.college_id = null;
              this.user.data.department_id = null;
              this.user.data.school_name = this.school_name;
            }
            this.user.data.city_id = this.city_id;
            this.$emit('completed',this.user);
          }
        }
   
    };
    
</script>
<style>
    
</style>


// WEBPACK FOOTER //
// src/components/Registeration/Cities.vue